
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/centralized-crypto-exchange-development",
      function () {
        return require("private-next-pages/centralized-crypto-exchange-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/centralized-crypto-exchange-development"])
      });
    }
  